export enum AggregateType {
  ALL_AGGREGATES = 0,
  PILLAR_SCORES = 1,
  AI_SUMMARY_TEAM = 2,
  SENTIMENT_SCORES = 3,
  GREATEST_STRENGTHS = 4,
  GREATEST_OPPORTUNITIES = 5,
  MEMBER_PILLARS = 6,
  DEPARTMENT_PILLARS = 7,
  CATEGORY_PILLARS = 8,
  OUTCOME_SCORES = 9,
  CATEGORY_OVERALL = 10,
  AI_DATA_PAYLOAD = 11,
  MEMBER_QUESTION_SCORES = 12,
  OPTION_QUESTION_SCORES = 13,
  CATEGORY_QUESTION_SCORES = 14,
  MEMBER_FEEDBACK = 15,
  AI_SUMMARY_ORGANIZATION = 16,
  AI_EMBEDDINGS = 17,
  OUTCOME_PREDICTIONS = 18,
  CARTESIAN_AVERAGES = 19,
  LOOKUP_PROPERTIES = 20,
  SURVEY_EXPORT = 22,
  SURVEY_COMPLETION_STATISTICS = 23,
  OPTION_OUTCOME_SCORES = 24,
  CATEGORY_OUTCOME_SCORES = 25,
  THEMES = 26,
  KEYWORDS = 27,
  TEAM_SUMMARY = 28,
  SENTIMENT_DISTRIBUTION = 29,
  TEAM_OUTCOME_METRICS = 30,
  TEAM_PILLAR_METRICS = 31,
  EMERGENT_THEMES = 32,
}
